document.addEventListener('DOMContentLoaded', () => {
    const menuButton = document.querySelector('.menu_btn');
    const closeButton = document.querySelector('.close_btn');
    const navMenu = document.querySelector('.nav_menu');
    const langSwitcher = document.querySelector('.lang-switcher');
    const langCurrentButton = langSwitcher?.querySelector('.lang-current');

    if (menuButton && navMenu) {
        menuButton.addEventListener('click', () => {
            navMenu.classList.toggle('active');
        });
    }
    if (closeButton && navMenu) {
        closeButton.addEventListener('click', () => {
            navMenu.classList.toggle('active');
        });
    }
    window.addEventListener("resize", () => {
        navMenu?.classList.remove('active');
        if (window.innerWidth > 960 && langSwitcher) {
            langSwitcher.classList.remove('is-open');
            langCurrentButton?.setAttribute('aria-expanded', 'false');
        }
    });

    if (langSwitcher && langCurrentButton) {
        const closeLangDropdown = () => {
            langSwitcher.classList.remove('is-open');
            langCurrentButton.setAttribute('aria-expanded', 'false');
        };

        const openLangDropdown = () => {
            langSwitcher.classList.add('is-open');
            langCurrentButton.setAttribute('aria-expanded', 'true');
        };

        langCurrentButton.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();

            if (langSwitcher.classList.contains('is-open')) {
                closeLangDropdown();
            } else {
                openLangDropdown();
            }
        });

        document.addEventListener('click', (event) => {
            if (!langSwitcher.contains(event.target)) {
                closeLangDropdown();
            }
        });

        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                closeLangDropdown();
            }
        });
    }

    const dropdownMenuGroups = document.querySelectorAll('.desktop_menu, .footer_menu_4');

    dropdownMenuGroups.forEach((menuGroup) => {
        const dropdownParents = menuGroup.querySelectorAll('.menu-item-has-children');

        if (!dropdownParents.length) {
            return;
        }

        const closeAllDropdowns = () => {
            dropdownParents.forEach((item) => {
                item.classList.remove('dropdown-open');
                item.querySelector('.dropdown_trigger')?.setAttribute('aria-expanded', 'false');
            });
        };

        dropdownParents.forEach((item) => {
            const trigger = item.querySelector('.dropdown_trigger');
            const submenu = item.querySelector('.dropdown_body');

            if (!trigger || !submenu) {
                return;
            }

            trigger.setAttribute('aria-haspopup', 'true');
            trigger.setAttribute('aria-expanded', 'false');

            trigger.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();

                const isOpen = item.classList.contains('dropdown-open');
                closeAllDropdowns();

                if (!isOpen) {
                    item.classList.add('dropdown-open');
                    trigger.setAttribute('aria-expanded', 'true');
                }
            });
        });

        document.addEventListener('click', (event) => {
            if (!menuGroup.contains(event.target)) {
                closeAllDropdowns();
            }
        });

        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                closeAllDropdowns();
            }
        });
    });

    document.querySelectorAll('.arrow_between_sections').forEach((arrow) => {
        let sibling = arrow.nextElementSibling;

        while (sibling) {
            if (sibling.classList.contains('arrow_between_sections')) {
                break;
            }

            if (sibling.matches('section')) {
                if (sibling.classList.contains('clip_corner_image')) {
                    arrow.classList.add('hi-potiont-image');
                } else if (sibling.classList.contains('clip_angle')) {
                    arrow.classList.add('hi-potiont-angle');
                } else if (sibling.classList.contains('clip_corner')) {
                    arrow.classList.add('hi-potiont');
                }
                break;
            }

            sibling = sibling.nextElementSibling;
        }
    });

    const accordionContainers = document.querySelectorAll('[data-accordion]');
    
    accordionContainers.forEach(container => {
        const accordionItems = container.querySelectorAll('.accordion_item');

        accordionItems.forEach(item => {
            const title = item.querySelector('.accordion_title');

            if (title) {
                title.addEventListener('click', () => {
                    // Usuwanie klasy 'active' z innych elementów
                    accordionItems.forEach(otherItem => {
                        if (otherItem !== item) {
                            otherItem.classList.remove('active');
                        }
                    });

                    // Dodanie klasy 'active' do klikniętego elementu
                    item.classList.toggle('active');
                });
            }
        });
    });

    document.querySelectorAll('.comparison_table').forEach((table) => {
        const getSidebarCell = (desc) => desc?.closest('.comparison_table__cell--sidebar');

        const closeFeatureDesc = (desc) => {
            desc.classList.remove('is-open');
            desc.setAttribute('aria-hidden', 'true');
            desc.hidden = true;
            getSidebarCell(desc)?.classList.remove('comparison_table__cell--feature-open');

            const infoBtn = desc.closest('.comparison_table__feature-info-wrap')?.querySelector('.comparison_table__feature-info');
            infoBtn?.setAttribute('aria-expanded', 'false');
        };

        const closeAllFeatureDescs = () => {
            table.querySelectorAll('.comparison_table__feature-desc.is-open').forEach((desc) => {
                closeFeatureDesc(desc);
            });
        };

        table.addEventListener('click', (event) => {
            const infoBtn = event.target.closest('.comparison_table__feature-info');
            if (infoBtn) {
                event.preventDefault();
                event.stopPropagation();

                const desc = infoBtn.closest('.comparison_table__feature-info-wrap')?.querySelector('.comparison_table__feature-desc');
                if (!desc) {
                    return;
                }

                const isOpen = desc.classList.contains('is-open');
                closeAllFeatureDescs();

                if (!isOpen) {
                    desc.classList.add('is-open');
                    desc.hidden = false;
                    desc.setAttribute('aria-hidden', 'false');
                    infoBtn.setAttribute('aria-expanded', 'true');
                    getSidebarCell(desc)?.classList.add('comparison_table__cell--feature-open');
                }

                return;
            }

            const closeBtn = event.target.closest('.comparison_table__feature-desc-close');
            if (closeBtn) {
                event.preventDefault();
                event.stopPropagation();

                const desc = closeBtn.closest('.comparison_table__feature-desc');
                if (desc) {
                    closeFeatureDesc(desc);
                }
            }
        });

        document.addEventListener('click', (event) => {
            if (!table.contains(event.target)) {
                closeAllFeatureDescs();
            }
        });

        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                closeAllFeatureDescs();
            }
        });
    });

    document.addEventListener('click', (event) => {
        const trigger = event.target.closest('#show-form-btn');
        if (!trigger) {
            return;
        }

        const section = document.querySelector('.form-section');
        if (!section) {
            return;
        }

        const hiddenForm = section.querySelector('.ff_force_hide');
        if (hiddenForm) {
            hiddenForm.classList.remove('ff_force_hide');
            hiddenForm.style.display = 'block';
        }

        const successMessage = section.querySelector('.ff-message-success');
        if (successMessage) {
            successMessage.style.display = 'none';
        }
    });
});